module.exports = __webpack_public_path__ + "media/cross_sell/Become_a_Lancaster_Customer-98940880.png";